<template>
    <div style="background-color: #1f2d3d" :style="{ height: this.screenHeight + 'px' }">
        <Board :rows="items" :span="3" v-cloak @init="loadConfig"></Board>
    </div>
</template>

<script>
import axios from 'axios'
import Board from './Board'
import { mapGetters } from 'vuex'
export default {
    name: `BoardSchedule`,
    components: { Board },
    props: {

    },
    data() {
        // 获取查询日期偏移值设置
        let offset = (this.$root.BoardScheduleQueryDateOffSet || ``).split(`,`)
        let startOffSetDate = 0
        let endOffSetDate = 0
        if (offset && offset.length == 2) {
            startOffSetDate = offset[0]
            endOffSetDate = offset[1]
        }
        return {
            page: 1,
            load_timer: {},
            load_message: {},
            speakFinish: {},
            all_page: 1,
            message: [],
            items: [],
            config: {},
            synth: window.speechSynthesis,
            boardConfigPageInterval: 10,
            boardConfigAudio: 1,
            isActive: true,
            token: sessionStorage.getItem(`token`),
            headers: [{
                in_room_time: {
                    label: `手术时间`,
                    span: 2
                },
                dic_operating_room: {
                    label: `手术间`,
                    span: 2
                },
                name: {
                    label: `病人姓名`,
                    span: 2
                },
                surgeries: {
                    label: `手术名称`,
                    span: 9
                },
                surgeon: {
                    label: `手术医生`,
                    span: 2
                },
                anes_doctor: {
                    label: `麻醉医师`,
                    span: 2
                },
                anaes_methods: {
                    label: `麻醉方式`,
                    span: 3
                },
                surgery_status: {
                    label: `状态`,
                    span: 2
                }
            }],
            queryDate: [this.$moment().add(startOffSetDate, `days`).format(`YYYY/MM/DD`), this.$moment().add(+endOffSetDate + 1, `days`).format(`YYYY/MM/DD`)]
        }
    },
    created() {
        if (this.load_timer) {
            clearInterval(this.load_timer)
        }
        this.timer()
    },
    computed: {
        ...mapGetters([`screenHeight`])
    },
    mounted() {
        this.loadScheduledList()
    },
    methods: {
        loadConfig(config) {
            this.config = config
        },
        loadScheduledList() {
            let data = []
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/Operation/BoardNotice/GetScheduledList`,
                        Object.assign({
                            headers: {
                                'Authorization': `bearer ${this.token}`
                            },
                            emulateJSON: true
                        }, {
                            params: {
                                date: this.queryDate[0],
                                enddate: this.queryDate[1],
                                page: this.page }
                        }))
                    .then((response) => {
                        if (response.status === 200) {
                            response.data = _.filter(response.data, (d) => {
                                return d.enum_surgery_status !== 10
                            })
                            let r = _.map(response.data, (d) => {
                                return {
                                    apply_time: {
                                        label: d.in_room_time == null ? `` : this.$moment(d.in_room_time).format(`HH:mm`),
                                        span: 2
                                    },
                                    dic_operating_room: {
                                        label: d.dic_operating_room,
                                        span: 2
                                    },
                                    name: {
                                        label: d.patient_name,
                                        span: 2
                                    },
                                    surgeries: {
                                        label: `${d.surgeries}`,
                                        span: 9
                                    },
                                    surgeon: {
                                        label: d.surgeon,
                                        span: 2
                                    },
                                    anes_doctor: {
                                        label: d.anes_doctor,
                                        span: 2
                                    },
                                    anes_assistants: {
                                        label: d.anaes_methods,
                                        span: 3
                                    },
                                    surgery_status: {
                                        label: d.surgery_status,
                                        span: 2
                                    }
                                }
                            })
                            this.all_page = response && response.other && response.other.all_page
                            this.page = this.page === this.all_page ? 1 : this.page + 1
                            data = this.headers.concat(r)
                            this.items = data
                            resolve(this.items)
                        } else {
                            return reject(response.msg)
                        }
                    })
                    .catch(e => {
                        if (e && e.data && e.status == `600`) {
                            ElementUI.Message.error(e.data && e.data.detail)
                        } else if (e && e.data) {
                            ElementUI.Notification.error({
                                title: `错误`,
                                message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                            })
                        }
                    })
            })
        },
        timer() {
            this.load_timer = setInterval(() => {
                if (this.isActive) {
                    this.loadScheduledList()
                }
            }, this.boardConfigPageInterval * 1000)
        }
    },
    destroyed() {
        clearInterval(this.load_timer)
    },
    watch: {
        config(oldObj, newObj) {
            this.boardConfigPageInterval = newObj.boardConfigPageInterval
        }
    }
}
</script>

<style scoped>
[v-cloak] {
    display: none !important;
}
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #1f2d3d;
}
.message {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 500px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    margin-top: -250px;
    margin-left: -400px;
    font-size: 64px;
}
.patient_name,
.note {
    height: 50%;
    line-height: 250px;
}
.active {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Board/BoardSchedule.vue